import LogUtil from "@/betby/utils/LogUtil";

const LOG_LEVEL = {
  NONE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
} as const;

const isDevelopment = process.env.NODE_ENV === "development";
const currentLogLevel = isDevelopment ? LOG_LEVEL.DEBUG : LOG_LEVEL.WARN;

export { isDevelopment };

export const logger = {
  debug: (...args: unknown[]) => {
    if (currentLogLevel >= LOG_LEVEL.DEBUG) {
      LogUtil.debug("[HTTP Debug]", ...args);
    }
  },
  info: (...args: unknown[]) => {
    if (currentLogLevel >= LOG_LEVEL.INFO) {
      LogUtil.info("[HTTP Info]", ...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (currentLogLevel >= LOG_LEVEL.WARN) {
      LogUtil.warn("[HTTP Warn]", ...args);
    }
  },
  error: (...args: unknown[]) => {
    if (currentLogLevel >= LOG_LEVEL.ERROR) {
      LogUtil.error("[HTTP Error]", ...args);
    }
  },
};
